import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const QrCodeModal = ({
  isOpen,
  onClose,
  qrValue, // The string you want to encode into the QR code
  title = 'Scan QR Code',
  description = 'Scan this code using your app to continue.',
  closeText = 'Close',
  retryText = 'Retry',
  onRetry,
}) => {
  const [hasError, setHasError] = useState(false);
  const [retryKey, setRetryKey] = useState(0);

  const handleRetry = () => {
    setHasError(false);
    setRetryKey(prev => prev + 1); // force QRCodeCanvas re-render
    if (onRetry) onRetry();
  };

  return (
    <div
      className={`modal fade ${isOpen ? 'show d-block' : ''}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: isOpen ? 'rgba(0, 0, 0, 0.5)' : 'transparent' }}
      aria-hidden={!isOpen}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body text-center p-5">
            {hasError ? (
              <>
                <h4 className="mb-3 text-danger">Failed to Generate QR</h4>
                <p className="text-muted mb-4">There was a problem generating the QR code. Please retry.</p>
                <button className="btn btn-warning" onClick={handleRetry}>
                  🔁 {retryText}
                </button>
              </>
            ) : (
              <>
                <div className="mb-4">
									{ console.log(`modal:`+qrValue)}
                  {qrValue ? (
                    <QRCodeCanvas
                      key={retryKey}
                      value={qrValue}
                      size={180}
                      level="H"
                      includeMargin={true}
                      onError={() => setHasError(true)}
                    />
                  ) : (
                    <p className="text-muted">No QR data provided.</p>
                  )}
                </div>
                <h4 className="mb-3">{title}</h4>
                <p className="text-muted mb-4">{description}</p>
              </>
            )}

            <div className="hstack gap-2 justify-content-center mt-3">
              <button className="btn btn-link link-success fw-medium" onClick={onClose}>
                <i className="ri-close-line me-1 align-middle"></i> {closeText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrCodeModal;